import { render, staticRenderFns } from "./LegacyView.vue?vue&type=template&id=0030ae13&scoped=true"
import script from "./LegacyView.vue?vue&type=script&lang=ts"
export * from "./LegacyView.vue?vue&type=script&lang=ts"
import style0 from "./LegacyView.vue?vue&type=style&index=0&id=0030ae13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030ae13",
  null
  
)

export default component.exports